/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { call } from 'redux-saga/effects';
import * as Sprites from './sprites';
import * as StreamWatchers from './streamWatchers';
import { activeStream, sprites } from './data';

export const ActionCreators = { sprites: Sprites.ActionCreators, streamWatchers: StreamWatchers.ActionCreators };

export default combineReducers({
  activeStream,
  sprites,
});

export const Selectors = {
  activeStream: StreamWatchers.Selectors,
  sprites: Sprites.Selectors,
};

export const sagas = [call(StreamWatchers.sagas), call(Sprites.sagas)];
